/**
 * DecileCell — render the CMS decile as a colored badge.
 *
 * Uses the `mips-decile` taxonomy registered in `src/lib/taxonomies.ts`.
 * Map: d1-d4 → danger, d5-d7 → warning, d8-d10 → success, na → neutral
 * (per the handoff §3.6 and §6.4).
 */
import { StatusBadge } from "@tensaw/visualization";
import { decileToKey } from "@/lib/format";

export interface DecileCellProps {
  decile: number | null | undefined;
}

export function DecileCell({ decile }: DecileCellProps) {
  return <StatusBadge taxonomy="mips-decile" status={decileToKey(decile)} size="compact" />;
}
